import React, { Component } from "react";
import WeddingListCard from "./WeddingListCard.js";

import "./WeddingList.css";

class WeddingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weddingTypesProgress: {
        white: 0,
        traditional: 0,
        reception: 0,
        court: 0
      },
      page: 1
    };
  }
  componentDidUpdate() {
    // This is causing issues when non progress info related updates happen
    const progressInfo = this.props.onProgressUpdate;
    this.refs[progressInfo[1]].onProgress(progressInfo[0]);
  }

  renderCards = () => {
    const itemsPerPage = 4;
    const { weddingTypesProgress, page } = this.state;
    let firstIndex,
      lastIndex = 0;
    firstIndex = (page - 1) * itemsPerPage;
    lastIndex = firstIndex + (itemsPerPage - 1);
    return Object.keys(weddingTypesProgress)
      .slice(firstIndex, lastIndex + 1)
      .map(item => {
        let type = item.charAt(0).toUpperCase() + item.slice(1, item.length);
        return (
          <div className="col-3 col-md-12 mx-auto">
            <WeddingListCard
              ref={item}
              wedding={{ type: type, progress: 0 }}
              isActive={this.props.activeWeddingType === item}
              onClick={this.props.onCardClick}
            />
          </div>
        );
      });
  };

  previousListPage = () => {
    this.setState({
      page: Math.max(this.state.page - 1, 0)
    });
  };

  nextListPage = () => {
    this.setState({
      page: Math.min(
        this.state.page + 1,
        Math.ceil(Object.keys(this.state.weddingTypesProgress).length / 3)
      )
    });
  };

  render() {
    return (
      <div className="row no-gutters">
        <div className="col-12 text-center" id="weddingListInfo">
          <h3>
            <b>Wedding event list</b>
          </h3>
          <p>Click to start </p>
        </div>

        <button className="mt-4 listButton" onClick={this.previousListPage}>
          {" "}
          P{" "}
        </button>
        {this.renderCards()}
        <button className="mt-4 listButton" onClick={this.nextListPage}>
          {" "}
          N{" "}
        </button>
      </div>
    );
  }
}

export default WeddingList;



// WEBPACK FOOTER //
// ./src/Builder/WeddingList/WeddingList.js